export default __webpack_public_path__ + "static/media/suitenupcias_6.837bbda8.jpg";